import { SITE_URL } from '../components/SEO';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Website Symphony',
  alternateName: 'Website Symphony Web Design',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description: 'Custom web design, development, A.I. integration and inbound marketing services for businesses across the United States.',
  email: 'Info@WebsiteSymphony.com',
  telephone: '+1-305-812-5999',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '420 NE 67th St, Suite 711-North',
    addressLocality: 'Miami Beach',
    addressRegion: 'FL',
    postalCode: '33141',
    addressCountry: 'US',
  },
  sameAs: [
    'https://www.facebook.com/websitesymphony',
    'https://twitter.com/websitesymphony',
    'https://www.instagram.com/websitesymphony',
    'https://www.youtube.com/@websitesymphony',
    'https://www.linkedin.com/company/websitesymphony',
  ],
};

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#business`,
  name: 'Website Symphony',
  image: `${SITE_URL}/og-image.jpg`,
  url: SITE_URL,
  telephone: '+1-305-812-5999',
  email: 'Info@WebsiteSymphony.com',
  priceRange: '$$-$$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '420 NE 67th St, Suite 711-North',
    addressLocality: 'Miami Beach',
    addressRegion: 'FL',
    postalCode: '33141',
    addressCountry: 'US',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 25.8420, longitude: -80.1236 },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '09:00', closes: '18:00' },
  ],
  areaServed: [
    { '@type': 'Country', name: 'United States' },
    { '@type': 'State', name: 'Florida' },
    { '@type': 'City', name: 'Miami' },
  ],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '5.0',
    reviewCount: '87',
  },
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Website Symphony',
  url: SITE_URL,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/portfolio?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const serviceSchema = (name, description, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: name,
  name,
  description,
  provider: { '@type': 'Organization', name: 'Website Symphony', url: SITE_URL },
  areaServed: { '@type': 'Country', name: 'United States' },
  url: `${SITE_URL}${path}`,
});

export const faqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map((i) => ({
    '@type': 'Question',
    name: i.q,
    acceptedAnswer: { '@type': 'Answer', text: i.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const combineSchemas = (...schemas) => ({
  '@context': 'https://schema.org',
  '@graph': schemas.filter(Boolean),
});
